module.exports = __webpack_public_path__ + "img/megaphone-2.060d7d35.svg";